import * as Yup from "yup";

export const validationCheck = {
  otp: (val) => {
    if (/[a-zA-Z!@#$%^&*\.\\\/\(\)\-\+\=\_\:\;\'\"\,\`\[\]\{\}]/.test(val)) {
      return "basicValidation.numbersOnly";
    }
    if (val > 0 && val.length < 4) {
      return "basicValidation.tooShort";
    }
    return "";
  },
  phone: (val, countryCode) => {
    // if(val.charAt(0) === '0'){
    //     return "Don't start with 0"
    if (val == "") return "basicValidation.missingFields";

    if (countryCode === "+60") {
      if (/[a-zA-Z!@#$%^&*\.\\\/\(\)\-\+\=\_\:\;\'\"\,\`\[\]\{\}]/.test(val)) {
        return "basicValidation.numbersOnly";
      }
      if (val.length > 10) {
        return "basicValidation.tooLong";
      }
      if (val.length < 9 && val.length > 0) {
        return "basicValidation.tooShort";
      }
      if (val.charAt(0) === ".") {
        return "basicValidation.numbersOnly";
      }
      return "";
    }
    if (countryCode === "+65") {
      if (/[a-zA-Z!@#$%^&*\.\\\/\(\)\-\+\=\_\:\;\'\"\,\`\[\]\{\}]/.test(val)) {
        return "basicValidation.numbersOnly";
      }
      if (val.length > 10) {
        return "basicValidation.tooLong";
      }
      if (val.length < 7 && val.length > 0) {
        return "basicValidation.tooShort";
      }
      if (val.charAt(0) === ".") {
        return "basicValidation.numbersOnly";
      }
      return "";
    }
    if (countryCode === "+91") {
      if (/[a-zA-Z!@#$%^&*\.\\\/\(\)\-\+\=\_\:\;\'\"\,\`\[\]\{\}]/.test(val)) {
        return "basicValidation.numbersOnly";
      }
      if (val.length > 10) {
        return "basicValidation.tooLong";
      }
      if (val.length < 10 && val.length > 0) {
        return "basicValidation.tooShort";
      }
      if (val.charAt(0) === ".") {
        return "basicValidation.numbersOnly";
      }
      return "";
    }
    if (/[a-zA-Z!@#$%^&*\.\\\/\(\)\-\+\=\_\:\;\'\"\,\`\[\]\{\}]/.test(val)) {
      return "basicValidation.numbersOnly";
    }
    if (val.length > 16) {
      return "basicValidation.tooLong";
    }
    if (val.length < 10 && val.length > 0) {
      return "basicValidation.tooShort";
    }
    if (val.charAt(0) === ".") {
      return "basicValidation.numbersOnly";
    }
    if (!val.startsWith("628")) {
      return "basicValidation.properFormat";
    }
    return "";
  },
  birthDate: (val) => {
    let currentDate = new Date();
    if (new Date(val)?.getTime() > currentDate?.getTime()) {
      return "basicValidation.futureDate";
    }

    return "";
  },
  dateJoined: (val) => {
    let currentDate = new Date();
    if (new Date(val)?.getTime() > currentDate?.getTime()) {
      return "basicValidation.futureDate";
    }

    return "";
  },
};

export const validate = (t) =>
  Yup.object().shape(
    {
      name: Yup.string()
        .required(t("basicValidation.missingFields"))
        .transform((originalValue) => {
          return originalValue ? originalValue.trim() : originalValue;
        }),
      gender: Yup.string().required(t("basicValidation.missingFields")),
      employeeId: Yup.string().required(t("basicValidation.missingFields")),
      status: Yup.string().required(t("basicValidation.missingFields")),
      suspensionCategory: Yup.string().when("status", {
        is: (status) => status === "inactive" || status === "withdraw_suspended",
        then: (schema) => schema.required(t("basicValidation.missingFields")),
      }),
      suspendedReason: Yup.string().when(["status", "suspensionCategory"], {
        is: (status, suspensionCategory) =>
          (status === "inactive" || status === "withdraw_suspended") &&
          suspensionCategory &&
          suspensionCategory.includes("Other"),
        then: (schema) => schema.required(t("basicValidation.missingFields")),
      }),
      payDate: Yup.string().when(["group", "groupPayDates"], {
        is: (group, groupPayDates) => {
          return !group && (groupPayDates || [])?.length !== 0;
        },
        then: (schema) => schema.required(t("basicValidation.pleaseSelectGroupFirst")),
        otherwise: (schema) => schema.required(t("basicValidation.missingFields")),
      }),
      salary: Yup.string()
        .required(t("basicValidation.missingFields"))
        .matches(/^\d+$/, t("basicValidation.numbersOnly"))
        .test({
          name: "maxLength",
          test: (val) => val && val.length < 13,
          message: t("basicValidation.tooLong"),
        })
        .test({
          name: "noLeadingZero",
          test: (val) => !val || val.charAt(0) !== "0",
          message: t("basicValidation.noZeros"),
        })
        .test({
          name: "noLeadingDot",
          test: (val) => !val || val.charAt(0) !== ".",
          message: t("basicValidation.numbersOnly"),
        }),
      ktp: Yup.string()
        .required(t("basicValidation.missingFields"))
        .matches(/^[0-9]*$/, t("basicValidation.numbersOnly"))
        .test({
          name: "maxLength",
          test: (val) => val && val.length <= 16,
          message: t("basicValidation.tooLong"),
        })
        .test({
          name: "minLength",
          test: (val) => val && val.length >= 16,
          message: t("basicValidation.tooShort"),
        })
        .test({
          name: "noLeadingDot",
          test: (val) => !val || val.charAt(0) !== ".",
          message: t("basicValidation.numbersOnly"),
        })
        .transform((originalValue) => {
          return originalValue.trim();
        }),
      bankNumber: Yup.string()
        .required(t("basicValidation.missingFields"))
        .test({
          name: "numbersOnly",
          test: (val) => {
            const trimmedValue = val.trim();
            return !/[a-zA-Z!@#$%^&*\.\\\/\(\)\-\+\=\_\:\;\'\"\,\`\[\]\{\}]/.test(trimmedValue);
          },
          message: "basicValidation.numbersOnly",
        })
        .transform((originalValue) => {
          return originalValue.trim();
        }),
      beneficiaryName: Yup.string()
        .required(t("basicValidation.missingFields"))
        .matches(/^[^!@#$%^&*\.\\\/\(\)\-\+\=\_\:\;\'\"\,0-9\`\[\]\{\}]*$/, t("basicValidation.lettersOnly")),
      group: Yup.string().when(["payDate", "groupPayDates"], {
        is: (payDate, groupPayDates) => {
          return !payDate && (groupPayDates || [])?.length !== 0;
        },
        then: (schema) => schema.required(t("basicValidation.missingFields")),
      }),
    },
    ["group", "payDate"],
  );
